import { modal, Text } from 'bold-ui'

interface CidadaoAusenteModalProps {
  hasPermission: boolean
  onConfirm: () => void
}

export const cidadaoAusenteModal = ({ hasPermission, onConfirm }: CidadaoAusenteModalProps) =>
  modal({
    title: 'Atenção',
    icon: {
      name: 'infoCircleOutline',
      fill: 'info',
    },
    size: 'small',
    closeOnBackdropClick: false,
    render: () => (
      <Text>
        Não é possível realizar atendimentos com cidadão ausente. É necessário atualizar o cadastro do cidadão com a
        data de retorno.
      </Text>
    ),
    actions: hasPermission
      ? [{ label: 'Cancelar' }, { label: 'Atualizar Cadastro', kind: 'primary', onClick: onConfirm }]
      : [{ label: 'Ok', kind: 'primary' }],
  })()
